export enum EntityChangeEventType {
  Note = 'NOTE',
  File = 'FILE',
  Accounting = 'ACCOUNTING',
  RelatedAccounting = 'RELATED_ACCOUNTING',
  Payment = 'PAYMENT',
  Audit = 'AUDIT',
  Notification = 'NOTIFICATION'
}
